import React, { useState, useEffect } from "react";
import { partnersAPI } from '../../Api';
import { useNavigate } from "react-router-dom";
import { styled, alpha } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Box, Button,TextField , Menu, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Toolbar, Typography, Paper, Checkbox, IconButton, Tooltip } from '@mui/material';
import { goodsAPI, imgAPI } from '../../Api';
import ProductModal from './ProductModal';
import ModalAccept from '../component/ModalAccept';
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const statusMarket = {
  "NO_PUBLIC": "Нет на маркете",
  "HAS_CARD_CAN_NOT_UPDATE": "Карточка Маркета",
  "HAS_CARD_CAN_UPDATE": "Можно дополнить",
  "HAS_CARD_CAN_UPDATE_ERRORS": "Изменения не приняты",
  "HAS_CARD_CAN_UPDATE_PROCESSING": "Изменения на проверке",
  "NO_CARD_NEED_CONTENT": "Создайте карточку",
  "NO_CARD_MARKET_WILL_CREATE": "Создаст Маркет",
  "NO_CARD_ERRORS": "Не создана из-за ошибки",
  "NO_CARD_PROCESSING": "Проверяем данные",
  "NO_CARD_ADD_TO_CAMPAIGN": "Разместите товар в магазине"
};
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  border: '1px solid #02010349',
  marginBottom: theme.spacing(2),
  backgroundColor: 'white',
  '&:hover': {
    backgroundColor: 'white',
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,

  },
}));
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: 'code',
    numeric: false,
    disablePadding: true,
    label: 'Код',
  },
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: 'Наименование',
  },
  {
    id: 'partner',
    numeric: true,
    disablePadding: false,
    label: 'Магазин',
  },
  {
    id: 'sku',
    numeric: true,
    disablePadding: false,
    label: 'Маркет ИД',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Статус',
  },
  {
    id: 'yandex_price',
    numeric: true,
    disablePadding: false,
    label: 'Yandex Цена',
  },
  {
    id: 'Market',
    numeric: true,
    disablePadding: false,
    label: 'Синхронизация',
  },
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}
            
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              sx={{opacity: 1}}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default function List() {
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [rows, setRows] = useState([]);
const [partners, setPartners] = useState([]);
const [partnerId, setPartnerId] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null); // Состояние для хранения выбранного товара
  const [anchorEl, setAnchorEl] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [toggleError, setToggleError] = useState(false);
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     updateRows(); // вызываем обновление каждые 10 сек
  //   }, 10000);
  
  //   updateRows(); // вызываем один раз сразу при монтировании
  
  //   return () => clearInterval(interval); // очищаем таймер при размонтировании
  // }, []);
  useEffect(() => {
    const sortData = (data) => {
      return data.sort((a, b) => {
        if (a[orderBy] < b[orderBy]) {
          return order === 'asc' ? -1 : 1;
        }
        if (a[orderBy] > b[orderBy]) {
          return order === 'asc' ? 1 : -1;
        }
        return 0;
      });
    };
    sortData(rows);
  }, [orderBy, order]);

  useEffect(() => {
    const getRows = async () => {
      const response = await goodsAPI.getGoods(page, rowsPerPage, '', '', partnerId);
      setTotalCount(response.data.pagination.totalCount);
      setRows(response.data.data);
      handleRequestSort('', 'calories');
    };
    
    getRows();
  }, [page, rowsPerPage, partnerId]); 

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  
 // Обработчик правого клика
 const handleRightClick = (event, product) => {
  event.preventDefault(); // Останавливаем стандартное меню браузера
  setSelectedProduct(product); // Устанавливаем выбранный продукт
  setAnchorEl({ top: event.clientY, left: event.clientX }); // Открываем меню рядом с курсором
};

// Закрыть меню
const handleCloseMenu = () => {
  setAnchorEl(null);
};
const navigate = useNavigate();
// Обработчики пунктов меню
const handleInfo = () => {
  console.log('Информация о продукте:', selectedProduct);
  setShowTooltip(true)
  handleCloseMenu();
};

const handleEdit = () => {
  navigate('/goods/edit/' + selectedProduct._id)
  handleCloseMenu();
  
};
const handleToggleError = async () => {
  const response = await goodsAPI.getGoods(page, rowsPerPage, '', toggleError ? '' : 'errors', partnerId);
  setTotalCount(response.data.pagination.totalCount);
  setRows(response.data.data);
  setToggleError(!toggleError);
};
const handleSearch = async (event) => {
  const searchQuery = event.target.value;
  const response = await goodsAPI.getGoods(page, rowsPerPage, searchQuery, '', partnerId);
  setTotalCount(response.data.pagination.totalCount);
  setRows(response.data.data);
console.log(searchQuery);
};
const handleDelete = () => {
  setOpenDelete(true)
  
};
const updateRows = async () => {
  try {
    const response = await goodsAPI.getGoods(page, rowsPerPage, '', '', partnerId);
    console.log(response.data.data);
    setRows(response.data.data);
  } catch (error) {
    console.log(error);
  }
}

const onDelete = async () => {
  const response = await goodsAPI.deleteGoods(selectedProduct._id);
  console.log(response.data);
  setOpenDelete(false);
  await updateRows();
  handleRequestSort('', 'calories');
  handleCloseMenu();
};
  const addMarket = async(id) => {
    const response = await goodsAPI.addMarket(id);
    try {
    if(response.data.success) {
      toast("Позиция успешно синхронизирована с маркет");
    await updateRows();
    handleRequestSort('', 'calories');
    handleCloseMenu();
}
} catch (error) {
    toast("Произошла неизвестная ошибка");
    console.log(error);
  }
};
  
  useEffect(() => {
    const fetchPartners = async () => {
        try {
            const { data } = await partnersAPI.getPartners();
            setPartners(data.data || []);
        } catch (e) {
            setPartners([]);
        }
    };
    fetchPartners();
}, []); 

  return (
    
    <Box sx={{ width: '100%' }}>
       <Menu
        open={Boolean(anchorEl)} // Меню открыто, если anchorEl не null
        onClose={handleCloseMenu}
        anchorReference="anchorPosition"
        anchorPosition={anchorEl ? { top: anchorEl.top, left: anchorEl.left } : undefined} // Позиционирование меню рядом с курсором
      >
        <MenuItem onClick={handleInfo}>Информация</MenuItem>
        <MenuItem onClick={handleEdit}>Редактировать</MenuItem>
         <MenuItem onClick={() => handleDelete()}>Удалить</MenuItem> {/* Клик на меню */}
         <ModalAccept 
          onConfirm={() => { onDelete(selectedProduct._id) }}
          onClose={() => {setOpenDelete(false)}}
          message="Вы уверены, что хотите удалить этот элемент?"
          open={openDelete} />
      
      </Menu>
      <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Поиск..."
              inputProps={{ 'aria-label': 'search' }}
              onChange={handleSearch}
            />
          </Search>
<Box display="flex" alignItems="center" >
  <Checkbox
   color="primary"
   onClick={handleToggleError}
   checked={toggleError}
  />
   <Box> Показать товары с ошибками </Box>
</Box>
      <Paper sx={{ width: '100%', mb: 2 }}>
        {/* Фильтр по магазину */}
      <div style={{ marginBottom: 16 }}>
        <TextField
          select
          label="Магазин"
          value={partnerId}
          onChange={e => setPartnerId(e.target.value)}
          style={{ minWidth: 200, marginRight: 16 }}
          SelectProps={{ native: true }}
        >
          <option value="">Все магазины</option>
          {partners.map((partner) => (
            <option key={partner._id} value={partner._id}>{partner.name}</option>
          ))}
        </TextField>
      </div>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size="small">
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={totalCount}
            />
            <TableBody>
              {rows.map((row, index) => {
          
                const isItemSelected = selected.includes(row._id);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row._id}
                    selected={isItemSelected}
                    onContextMenu={(e) => handleRightClick(e, row)} // Обработчик правого клика

                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        onClick={(event) => handleClick(event, row._id)}
                        checked={isItemSelected}
                        inputProps={{
                          'aria-labelledby': labelId,
                        }}
                        sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}
                      />
                    </TableCell>
                    <TableCell  sx={{ border: '1px solid rgba(224, 224, 224, 1)' }} component="th" id={labelId} scope="row" padding="none" align="center">
                      {row.code}
                    </TableCell>
                    <TableCell  sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}align="center">{row.name}</TableCell>
                    <TableCell  sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}align="center">{row.partner_id?.name || 'Не указано'}</TableCell>
                    <TableCell  sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}align="center">{row.sku}</TableCell>
    
                      <TableCell sx={{ border: '1px solid rgba(224, 224, 224, 1)'}} align="center">{statusMarket[row.status]}</TableCell>
                 

                    <TableCell  sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}align="center">{row.yandex_price}</TableCell>
                   
                      <TableCell sx={{ border: '1px solid rgba(224, 224, 224, 1)' }} align="center"><Button
                      onClick={() => addMarket(row._id)}>Синхронизировать</Button></TableCell>
      
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* Модальное окно с подробной информацией о товаре */}
      {showTooltip && (
       <ProductModal showTooltip={showTooltip} selectedProduct={selectedProduct} setShowTooltip={setShowTooltip}  />
      )}
      <ToastContainer />
    </Box>
    
  );
}
